import "./Card.css";
import icon_11 from "../../../../../assets/icon_11.png";
import icon_10 from "../../../../../assets/icon_10.png";

const Card = () => {
 return (
  <div className="payouts-card-container">
   <div className="payouts-card">
    <div className="wrapper">
     <div className="payouts-card-left">
      <p className="payouts-card-title">AVAILABLE BALANCE</p>
      <p className="payouts-card-text">$2,489</p>
     </div>
     <div className="payouts-card-right">
      <img src={icon_10} alt="product" />
     </div>
    </div>
   </div>

   <div className="payouts-card">
    <div className="wrapper">
     <div className="payouts-card-left">
      <p className="payouts-card-title">TOTAL EARNINGS</p>
      <p className="payouts-card-text">$2,489</p>
     </div>
     <div className="payouts-card-right">
      <img src={icon_11} alt="product" />
     </div>
    </div>
   </div>

   <div className="payouts-shapBtn-container">
    <a href="/" className="shapBtn">
     Request Payout
    </a>
   </div>
  </div>
 );
};

export default Card;
